import { createConfig, http } from 'wagmi';
import { polygon } from 'wagmi/chains';
import { injected } from 'wagmi/connectors';

// The walletConnect connector is intentionally omitted here.
// Mobile WalletConnect connections are handled by the custom QR modal
// (wallet-connect-modal.tsx → EthereumProvider.init), which creates a
// fresh session each time. The static wagmi connector was causing
// "session topic doesn't exist" errors on every page load because wagmi
// tried to auto-reconnect stale/expired WalletConnect sessions.
export const wagmiConfig = createConfig({
  chains: [polygon],
  connectors: [
    injected(),
  ],
  transports: {
    [polygon.id]: http('https://polygon-rpc.com'),
  },
});
